import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import api from '@/lib/api'
import { useAccessToken } from '@/features/auth/state/auth'
import { signatureClientKey } from '../helpers/signature-query-key'

type SignatureDTO = any // tipar conforme sua API

type Options = Omit<
  UseQueryOptions<SignatureDTO, unknown, SignatureDTO, ReturnType<typeof signatureClientKey>>,
  'queryKey' | 'queryFn'
>

export function useFetchSignatureByIdVerifed(id_owner?: string, options?: Options) {
  const token = useAccessToken()
  return useQuery({
    queryKey: signatureClientKey(id_owner),
    queryFn: async () => {
      if (!id_owner) throw new Error('Signature id_owner is required')
      const { data } = await api.get(`/signatures/owner/${id_owner}`, {
        headers: { Authorization: `Bearer ${token}` }
      })
      if (!data?.data) throw new Error('Signature not found')
      return data.data as SignatureDTO
    },

    placeholderData: undefined,
    staleTime: 0,
    refetchOnMount: 'always',
    gcTime: 1000 * 60 * 5,
    // permite o chamador ajustar algumas opções úteis
    retry: options?.retry ?? 1,
    refetchOnWindowFocus: options?.refetchOnWindowFocus ?? false,
    enabled: Boolean(id_owner) && (options?.enabled ?? true),
    select: raw => {
      // Faça cópia profunda se precisar enriquecer
      const clone = structuredClone ? structuredClone(raw) : JSON.parse(JSON.stringify(raw))
      // opcional: normalização aqui, sem mutar o cache original em outros lugares
      return clone
    }
  })
}
